<template>
  <div>
    <div v-if="flag" class="cover"></div>
    <!--中文模板-->
    <transition name="bounce">
      <div v-show="flag && language==0" class="box">
        <div class="header">
          <div class="title">登录</div>
          <span class="close" @click="closeLogin">
             <icon iconClass="fa-times"></icon>
          </span>
        </div>
        <div class="container">
          <Form ref="formLoginPhone" :model="phoneLogin" :rules="rulePhoneLogin"  :label-width="120">
            <Form-item prop="phone" label="手机号码">
              <Input type="text" v-model="phoneLogin.phone" style="width: 300px" placeholder="请输入手机号码">
              </Input>
            </Form-item>
            <Form-item prop="code" label="验证码">
              <Input type="text" v-model="phoneLogin.code" style="width: 200px" placeholder="请输入验证码">
              </Input>
              <div class="yan" @click="getCode">{{success}}</div>
            </Form-item>
          </Form>
          <div class="login-box">
            <Button type="error" @click="handleSubmit('formLoginPhone')">登录</Button>
          </div>
          <div class="yan2">
            收不到验证码? 试试 <span @click="getYuCode">语音验证码</span>
          </div>
        </div>
      </div>
    </transition>

    <!--英语模板-->
    <transition name="bounce">
      <div v-show="flag && language==1" class="box email-box">
        <div v-if="regMsg">
          <div class="header">
            <div class="title">sign in</div>
            <span class="close" @click="closeLogin">
             <icon iconClass="fa-times"></icon>
            </span>
          </div>
          <div class="container">
            <Form ref="formLoginEmail" :model="emailLogin" :rules="ruleEmailLogin"  :label-width="120">
              <Form-item prop="email" label="email">
                <Input type="text" v-model="emailLogin.email" style="width: 300px" placeholder="please type your email">
                </Input>
              </Form-item>

              <Form-item prop="password" label="password">
                <Input type="password" v-model="emailLogin.password" style="width: 300px" placeholder="please type your email">
                </Input>
              </Form-item>

            </Form>
          </div>
          <div class="login-box email-login">
            <Button type="error" @click="handleSubmit('formLoginEmail')">sign in</Button>
          </div>
          <div class="reg-box">
            <a @click="regShow" href="#">Create an account</a>
          </div>
        </div>

        <!--注册开始-->
        <div v-if="!regMsg">
          <div class="header">
            <div class="title">sign up</div>
            <span class="close" @click="closeLogin">
             <icon iconClass="fa-times"></icon>
            </span>
          </div>
          <div class="reg-container">
            <Form ref="formCustom" :model="formCustom" :rules="ruleCustom"  :label-width="120">
              <Form-item prop="email" label="email">
                <Input type="text" v-model="formCustom.email" style="width: 300px" placeholder="please type your email">
                </Input>
              </Form-item>

              <Form-item prop="password" label="password">
                <Input type="password" v-model="formCustom.password" style="width: 300px" placeholder="please type your Password">
                </Input>
              </Form-item>

              <Form-item prop="passwdCheck" label="confirm">
                <Input type="password" v-model="formCustom.passwdCheck" style="width: 300px" placeholder="plaese confirm your Password">
                </Input>
              </Form-item>

              <Form-item>
                <Button type="error" @click="handleSubmit('formCustom')">sign up</Button>
                <Button type="ghost" @click="handleReset('formCustom')" style="margin-left: 8px">reset</Button>
              </Form-item>
            </Form>
          </div>
          <div class="reg-box">
            <a @click="loginShow" href="#">sign in</a>
          </div>
        </div>
      </div>
    </transition>
  </div>

</template>
<script>
  import md5 from 'md5';
  import icon from '../icon'
  export default{
    data(){
//        邮箱验证规则
      let reg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/;
//      手机验证规则
      let phoneReg = /^1[3|4|5|7|8][0-9]{9}$/;

      const validateEmail = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('email is required!'));
        }else if(!reg.test(value)){
          callback(new Error('email is not valid!'));
        } else {
          callback();
        }
      };
      const validatePhone = (rule,value,callback)=>{
        if (value === '') {
          callback(new Error('手机号码不能为空'));
        }else if(!phoneReg.test(value)){
          callback(new Error('请输入合法的手机号码'));
        } else {
          callback();
        }
      };

      const validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('email is required!'));
        } else {
          if (this.formCustom.passwdCheck !== '') {
            // 对第二个密码框单独验证
            this.$refs.formCustom.validateField('passwdCheck');
          }
          callback();
        }
      };
      const validatePassCheck = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('please confirm your password!'));
        } else if (value !== this.formCustom.password) {
          callback(new Error("password is not equal"));
        } else {
          callback();
        }
      };
      return {
        phone: "",
        code: "",
        canGet: 60,
        phone_message: {flag: false, message: "请输入手机号码"},
        code_message: {flag: false, message: "请输入验证码"},
        timer: "",
        password: "",
        email: "",
        regMsg: true,
        success:"获取验证码",
//   手机号码验证登录
        phoneLogin:{
          phone: '',
          code: '' //验证码
        },
//   手机号码验证登录规则
        rulePhoneLogin:{
          phone:[
            { validator: validatePhone,required: true, }
          ],
          code: [
            { required: true, message: '验证码不能为空' }
          ]
        },
//        邮箱登录验证
        emailLogin:{
          email: '',
          password: ''
        },
//        邮箱登录规则
        ruleEmailLogin:{
          email:[
            { validator: validateEmail,required: true, }
          ],
          password: [
            { required: true, message: 'plaese type your password' }
          ]
        },
        formCustom: {
          email: '',
          password: '',
          passwdCheck: ''
        },
        ruleCustom: {
          email: [
            { validator: validateEmail }
          ],
          password: [
            { validator: validatePass }
          ],
          passwdCheck:[
            { validator: validatePassCheck,required: true }
          ]
        }
      }
    },
    props: {
      flag: {
        type: Boolean,
        default: false,
        require: true
      },
      language: {
        type: Number,
        default: 0
      }
    },
    computed: {
      success(){
        if (this.language === 0) {
          return '获取验证码'
        } else if (this.language === 1) {
          return 'get code';
        }
      }
    },
    components: {
      icon
    },
    methods: {
      change(prop1, model, phone){
        if (phone === 0) {
          let reg = /^1[3|4|5|7|8][0-9]{9}$/;
          if (!reg.test(this.phone)) {
            this[prop1].message = "请输入正确的手机号码";
            this[prop1].flag = true;
            return;
          } else {
            this[prop1].message = "请输入手机号码";
          }
        }
        if (this[model].length <= 0) {
          this[prop1].flag = true;
        } else {
          this[prop1].flag = false;
        }
      },
      closeLogin(){
        this.$emit("closeLogin");
      },
//          获取验证码
      getCode(){
        if (!this.phoneLogin.phone) {
          this.$Message.warning('请输入手机号码', 2);
          this.phone_message.flag = false;
          return;
        }
        if (this.timer) return;
        axios.post('/medapp/api/register/identify', {
          phone: this.phoneLogin.phone,
          type: "LOGIN"
        })
          .then((response) => {
            console.log(response.data);
            let _self = this;
//            如果发送验证码成功
//            if(response.)
            let data = response.data;
//            用户没有注册，发送验证码成功
//            debugger;
            if (data.code === "0") {
              this.$Message.warning('验证码已发送，请查收', 2);
              let temp = 60;
              _self.timer = setInterval(() => {
                temp--;
                _self.success = temp + "s 后重试";
                if (temp <= 0) {
                  if (this.language === 0) {
                    _self.success = "获取验证码";
                  } else {
                    _self.success = "get code";
                  }
                  clearInterval(_self.timer);
                  _self.timer = "";
                }
              }, 1000);
            }
          })
      },
//      获取语音验证码
      getYuCode(){
        if (!this.phone) {
          this.$Message.warning('请输入手机号码', 2);
          this.phone_message.flag = false;
          return;
        }
        axios.post('/medapp/api/register/identify', {
          phone: this.phone,
          type: "VLOGIN"
        }).then((response) => {
            console.log(response);
          this.$Message.warning('验证码将以来电形式告知,请注意接听,并填写来电中听到的4位验证码', 2);
        })
      },
      loginPhone(){
        axios.post('/medapp/api/register/web/login', {
          phone: this.phoneLogin.phone,
          identify: this.phoneLogin.code
        })
          .then((response) => {
            this.phoneLogin.code = '';
            let data = response.data;
            if (response.data.code === "0") {
              this.code = "";
              let user = {
                phone: this.phoneLogin.phone,
                registered: data.registered,
                token: data.token.tToken,
                uId: data.user.uId
              };
              this.$emit('loginUser', user);
            } else {
              // this.code_message.flag = true;
              // this.code_message.message = "验证码错误";
              this.$Message.warning('验证码错误', 2);
            }
          })
      },
      logInEmail(){
        axios.post('/medapp/api/register/web/login', {
          "email": this.emailLogin.email,
          "pwd": md5(this.emailLogin.password)
        })
          .then((response) => {
            let data = response.data;
            if (data.code == 0) {
              let user = {
                phone: this.emailLogin.email,
                registered: data.registered,
                token: data.token.tToken,
                uId: data.user.uId
              };
              this.$emit('loginUser', user);
            } else {
              this.$Message.warning('用户名或者密码错误', 2);
            }
          })
      },
      regShow(){
        this.regMsg = false;
      },
      loginShow(){
        this.regMsg = true;
      },
      handleSubmit(name) {
        this.$refs[name].validate((valid) => {
          if (valid) {
//            this.$Message.success('提交成功!');
            if(name === 'formCustom'){
              this.regEmail();
            }
            if(name === 'formLoginEmail'){
              this.logInEmail();
            }
            if(name==="formLoginPhone"){
              this.loginPhone();
            }
          } else {
//            this.$Message.error('表单验证失败!');
          }
        })
      },
      handleReset (name) {
        this.$refs[name].resetFields();
      },
      //用邮箱注册
      regEmail(){
        axios.post('/medapp//api/register/add', {
          email: this.formCustom.email,
          pwd: md5(this.formCustom.password)
        })
          .then((response) => {
            let data = response.data;
            if(data.code == -1){
              this.$Message.error('this email is already reg');
            }
            if(data.code == 0){
              this.$Message.info('success!');
            }
          })
      }
    }
  }
</script>
<style scoped>
  .cover {
    position: fixed;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .7);
    z-index: 12;
    left: 0;
    top: 0;
  }
  .box {
    font-size: 14px;
    background-color: #fff;
    width: 480px;
    box-sizing: border-box;
    height: 400px;
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    border-radius: 20px;
    overflow: hidden;
    z-index: 12;
  }

  .header {
    position: relative;
    color: #fff;
    background-color: #B30907;
    line-height: 40px;
    text-align: center;
    font-size: 18px;
  }

  .close {
    position: absolute;
    display: inline-block;
    box-sizing: border-box;
    right: 20px;
    top: 0;
    cursor: pointer;
  }

  .container {
    padding: 80px 0 0 0;
  }

  .label {
    width: 74px;
    display: inline-block;
    color: #000;
    font-size: 16px;

  }

  .item {
    margin-bottom: 20px;
    position: relative;
  }

  .yan {
    border-radius: 20px;
    padding: 2px 12px;
    border: 0;
    color: #fff;
    background-color: #F39900;
    cursor: pointer;
    font-size: 14px;
    display: inline-block;
  }

  .input {
    height: 35px;
    width: 180px;
    border: 1px solid #eee;
    padding: 5px;
    border-radius: 8px;
  }

  .yan2 {
    margin: 40px 0 0 0;
    font-size: 14px;
    text-align: center;
  }

  .yan2 span {
    color: #FD0B11;
    cursor: pointer;
  }

  .login {
    border-radius: 5px;
    background-color: #FD0B11;
    display: inline-block;
    color: #fff;
    padding: 4px 20px;
    cursor: pointer;
    line-height: 2;
    font-size: 14px;
  }

  .bounce-enter-active {
    animation: bounce-in .5s;
  }

  .bounce-leave-active {
    animation: bounce-out .5s;
  }

  @keyframes bounce-in {
    0% {
      transform: scale(0) translate(-50%, -50%);
      left: 50%;
    }
    50% {
      left: 50%;
      transform: scale(1.5) translate(-50%, -50%);
    }
    100% {
      left: 50%;
      transform: scale(1) translate(-50%, -50%);
    }
  }

  @keyframes bounce-out {
    0% {
      top: 50%;
      left: 50%;
    }
    50% {
      top: 60%;
      left: 50%;
    }
    100% {
      top: -100%;
      left: 50%;
    }
  }

  .login-box {
    text-align: center;
    margin-top: 50px;
  }

  .message {
    position: absolute;
    left: 80px;
    color: red;
  }

  .email-login {
    margin-top: 62px;
  }

  .email-box .label {
    width: 80px;
    text-align: right;
    margin-right: 30px;
  }

  .email-box label input {
    width: 220px;
  }

  .reg-box {
    text-align: right;
    padding-right:27px;
    margin-top: 20px;
  }

  .reg-button-box {
    text-align: center;
  }
  .reg-container{
    margin-top: 40px;
  }
  .ivu-btn-error {
    color: #fff;
    background-color: #e2ce2a;
    border-color: #e2ce2a;
  }
</style>



// WEBPACK FOOTER //
// iLogin.vue?40b0d2d8